module.exports = __webpack_public_path__ + "static/media/local-community-occasion-grid-1.02c4a264.jpg";